export type MultiselectComboboxOption = {
  value: string
  label: string
  /** Shorter text for the selected chip. Falls back to `label`. */
  chipLabel?: string
}

export type MultiselectComboboxPreviewState =
  | 'default'
  | 'focused'
  | 'filled'
  | 'disabled'
  | 'error'
  | 'expanded'
  | 'with-tooltip'
  | 'optional'
  | 'with-info'

export const MULTISELECT_COMBOBOX_PREVIEW_STATES: MultiselectComboboxPreviewState[] =
  [
    'default',
    'focused',
    'filled',
    'disabled',
    'error',
    'expanded',
    'with-tooltip',
    'optional',
    'with-info',
  ]

export const MULTISELECT_COMBOBOX_PREVIEW_STATE_LABELS: Record<
  MultiselectComboboxPreviewState,
  string
> = {
  default: 'Default',
  focused: 'Focused',
  filled: 'Filled',
  disabled: 'Disabled',
  error: 'Error',
  expanded: 'Expanded',
  'with-tooltip': 'With tooltip',
  optional: 'Optional',
  'with-info': 'With info',
}

export const MULTISELECT_COMBOBOX_DEMO_LABEL = 'Procedures'

export const MULTISELECT_COMBOBOX_DEMO_PLACEHOLDER = 'Type to search'

export const MULTISELECT_COMBOBOX_DEMO_OPTIONS: MultiselectComboboxOption[] = [
  {
    value: 'D8680',
    label: 'D8680 - removal of fixed orthodontic appliances',
    chipLabel: 'D8680',
  },
  {
    value: 'D1321',
    label:
      'D1321 - counseling for the control and prevention of adverse oral, behavioral, and systemic health effects',
    chipLabel: 'D1321',
  },
  {
    value: 'D5821',
    label: 'D5821 - interim partial denture - mandibular',
    chipLabel: 'D5821',
  },
  {
    value: 'D1208',
    label: 'D1208 - topical application of fluoride – excluding varnish',
    chipLabel: 'D1208',
  },
  {
    value: 'D1553',
    label:
      'D1553 - re-cement or re-bond unilateral space maintainer - per quadrant',
    chipLabel: 'D1553',
  },
  { value: 'D1120', label: 'D1120 - Prophylaxis - Child', chipLabel: 'D1120' },
]

export const MULTISELECT_COMBOBOX_DEMO_SELECTED_VALUES = [
  'D8680',
  'D1321',
  'D5821',
]

/** Typed text shown by the `expanded` preview so the menu renders a filtered list. */
export const MULTISELECT_COMBOBOX_DEMO_QUERY = 'd1'

export const MULTISELECT_COMBOBOX_DEMO_ERROR_MESSAGE = 'Error description'

export const MULTISELECT_COMBOBOX_DEMO_INFO_MESSAGE = 'Info text'

export const MULTISELECT_COMBOBOX_EMPTY_MESSAGE = 'No matching options'

export type MultiselectComboboxProps = {
  label?: string
  placeholder?: string
  options?: MultiselectComboboxOption[]
  value?: string[]
  defaultValue?: string[]
  /** Cap the number of selections. Remaining options are disabled once reached. */
  maxSelected?: number
  /**
   * Cap how many selected chips render in the control. Extra selections show as
   * an ellipsis. Omitted = show every chip.
   */
  maxVisibleSelected?: number
  /** Filter options as the user types. Defaults to true. */
  filterable?: boolean
  /** Close the menu after each selection. Defaults to false so several can be picked. */
  closeOnSelect?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  optional?: boolean
  showTooltip?: boolean
  className?: string
  /** dark-mode palette. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: MultiselectComboboxPreviewState
  onChange?: (values: string[]) => void
  onRemove?: (value: string) => void
}
